import {
  trackCheckoutStepEvent,
  trackClickEvent,
  trackFormEnterEvent,
  trackFormFieldErrorEvent,
  trackFormLeaveEvent,
  trackFormNavigationEvent,
  trackPageViewEvent,
  trackPostConversionCompletedEvent,
  trackPostConversionEnteredEvent,
  trackPostConversionQuestionSubmittedEvent,
  trackReachedContactFormEvent,
  trackSessionStartEvent,
  trackVisibilityEvent,
} from './events'

/**
 * Bind event bus events to Statsig tracking
 *
 * @param {object} Vue
 * @param {object} options
 * @param {object} options.statsigClient
 */
export function bindEvents(Vue, { statsigClient }) {
  Vue.$eventBus.onceOnSessionStartEvent(() => {
    trackSessionStartEvent(statsigClient)
  })

  Vue.$eventBus.onPageViewEvent((event) => {
    trackPageViewEvent(statsigClient, event)
  })

  Vue.$eventBus.onCheckoutStepEvent((event) => {
    trackCheckoutStepEvent(statsigClient, event)
  })

  Vue.$eventBus.onClickEvent((event) => {
    trackClickEvent(statsigClient, event)
  })

  Vue.$eventBus.onVisibilityEvent((event) => {
    trackVisibilityEvent(statsigClient, event)
  })

  Vue.$eventBus.onFormEnterEvent((event) => {
    trackFormEnterEvent(statsigClient, event)
  })

  Vue.$eventBus.onFormLeaveEvent((event) => {
    trackFormLeaveEvent(statsigClient, event)
  })

  Vue.$eventBus.onFormNavigationEvent((event) => {
    trackFormNavigationEvent(statsigClient, event)
  })

  Vue.$eventBus.onFormFieldErrorEvent((event) => {
    trackFormFieldErrorEvent(statsigClient, event)
  })

  Vue.$eventBus.onFormFieldValidEvent((event) => {
    // This event is very high-volume, so we may want to sample it in the future
    // trackFormFieldValidEvent(statsigClient, event)
  })

  Vue.$eventBus.onPostConversionEnteredEvent((event) => {
    trackPostConversionEnteredEvent(statsigClient, event)
  })

  Vue.$eventBus.onPostConversionCompletedEvent((event) => {
    trackPostConversionCompletedEvent(statsigClient, event)
  })

  Vue.$eventBus.onPostConversionQuestionSubmittedEvent((event) => {
    trackPostConversionQuestionSubmittedEvent(statsigClient, event)
  })

  Vue.$eventBus.onReachedContactFormEvent((event) => {
    trackReachedContactFormEvent(statsigClient, event)
  })
}
